@let _image = image();

@if (_image) {
  <ideals-illustration [name]="_image" [size]="imageSize()"/>
}

@if (title() || message()) {
  <div
    class="ideals-page-placeholder-text"
    fxGap="smaller"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    @if (title() || titleTemplateRef()) {
      <div class="ideals-page-placeholder-title">
        @if (title()) {
          {{ title() | idealsTranslate }}
        } @else {
          <ng-container *ngTemplateOutlet="titleTemplateRef()!"/>
        }
      </div>
    }

    @if (message() || messageTemplateRef()) {
      <div class="ideals-text-secondary ideals-page-placeholder-message">
        @if (message()) {
          <span [innerHTML]="message() | idealsTranslate | sanitize"></span>
        } @else {
          <ng-container *ngTemplateOutlet="messageTemplateRef()!"/>
        }
      </div>
    }
  </div>
}

<div class="ideals-buttons-group ideals-page-placeholder-actions">
  <ng-content/>
</div>
